import { render, staticRenderFns } from "./ContactoProveedorTable.vue?vue&type=template&id=46aa2651&"
import script from "./ContactoProveedorTable.vue?vue&type=script&lang=js&"
export * from "./ContactoProveedorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports